export class BaseSendAssetsContainerComponent {}
